const ABFieldCombineCore = require("../../core/dataFields/ABFieldCombineCore");
module.exports = class ABFieldCombine extends ABFieldCombineCore {};
